import { Box, IconButton, Stack } from "@mui/material";
import { Edit2, Eye } from "iconsax-react";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
interface IDeleteActionProps {
  link: string;
  Icon?: ReactNode;
}

export default function FilterLinkAction({
  link,
  Icon,
}: Readonly<IDeleteActionProps>) {
  return (
    <IconButton
      sx={{
        padding: "4px",
        borderRadius: "50%",
        width: "fit-content",
        cursor: "pointer",
        "&:hover": {
          color: (theme) => theme.palette.others.done,
        },
      }}
    >
      <Stack
        component={Link}
        to={link}
        color={(theme) => theme.palette.dominant.main}
        sx={{
          "&:hover": {
            color: (theme) => theme.palette.others.link,
          },
        }}
      >
        {Icon ?? <Eye size="18" />}
      </Stack>
    </IconButton>
  );
}
